import { render } from "./DeleteOrderPerm.vue?vue&type=template&id=1c9a931a&scoped=true"
import script from "./DeleteOrderPerm.vue?vue&type=script&lang=js"
export * from "./DeleteOrderPerm.vue?vue&type=script&lang=js"

import "./DeleteOrderPerm.vue?vue&type=style&index=0&id=1c9a931a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c9a931a"]])

export default __exports__